import { Action } from '../types/Action';
import { UserAction } from '../types/UserAction';

/**
 * Transforms the deprecated `Action[]` interface to `UserAction[]`.
 * Supports backward compatibility for onClick(action) and isActive -> status.
 */
export const DEPRECATED_actionsToUserActions = (
  actions: Action[],
  mode: 'icon' | 'chip' | 'link' = 'icon',
): UserAction[] =>
  actions.map((action) => {
    const { label, value, onClick, isActive, ...rest } = action;
    const userAction: UserAction = {
      ...rest,
      mode,
      text: label,
      ...(isActive && { status: 'active' as const }),
      ...(onClick && {
        onClick: () => onClick(action as Action<typeof value>),
      }),
    };
    return userAction;
  });
